var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOvcIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 19.25V17.4167C14.6667 16.4442 14.2804 15.5116 13.5928 14.8239C12.9052 14.1363 11.9725 13.75 11.0001 13.75H4.58342C3.61095 13.75 2.67832 14.1363 1.99069 14.8239C1.30306 15.5116 0.916748 16.4442 0.916748 17.4167V19.25M15.5834 10.0833L17.4167 11.9167L21.0834 8.25M11.4584 6.41667C11.4584 8.44171 9.81679 10.0833 7.79175 10.0833C5.7667 10.0833 4.12508 8.44171 4.12508 6.41667C4.12508 4.39162 5.7667 2.75 7.79175 2.75C9.81679 2.75 11.4584 4.39162 11.4584 6.41667Z",
    stroke: "#47474F",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvcIcon);
export default __webpack_public_path__ + "static/media/OVCIcon.f1d16741350e48df56f896be576a3325.svg";
export { ForwardRef as ReactComponent };